
export function home(start,limit){
    return `/pos?start=${start}&limit=${limit}`;
}


